export const AUTOMATIC = {
  value: "AUTOMATIC",
  key: "clients.form.additionalConfigurations.automaticOption",
};
export const MANUAL = {
  value: "MANUAL",
  key: "clients.form.additionalConfigurations.manualOption",
};
export default [AUTOMATIC, MANUAL];



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/enums/automaticMemberIdentifierOptions.js